import { Component, HostBinding } from "@angular/core";
import { BaseComponent, sleep, Transfer, PageService, PageComponent } from "common";
import { TopicApi, ApiTopic, PagesApi, ApiTopicItem } from "api";

export interface TopicWithItem extends ApiTopic {
    item: ApiTopicItem;
}

@Component({
    selector: 'tyt-topics-index',
    templateUrl: 'topics-index.component.html',
    styleUrls: ['./topics-index.component.scss']
})
export class TopicsIndexComponent extends PageComponent {
    constructor(
        private topicsApi: TopicApi,
        private pageApi: PagesApi,
        private pageService: PageService
    ) {
        super(pageService);
    }

    @Transfer()
    loading = true;

    @Transfer()
    topics: TopicWithItem[];

    @Transfer()
    @HostBinding('class.animate-in')
    animateIn = false;

    categories = [
        {
            label: 'Topics',
            type: 'topic',
            focusable: true
        }
    ];

    topicsOfType(type: string) {
        return this.topics.filter(x => x.topic_type === type);
    }

    async init() {
        if (!this.hasServerState) {
            let page = await this.pageApi.getTopicsPage().toPromise();

            this.topics = page.rows.map(x => Object.assign(x.topic, { item: x.topic_items[0] }));
            this.loading = false;

            await sleep(1);
            this.animateIn = true;
        }
    }
}